<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { computed } from 'vue'
import { ObjectTypes } from '@/entities/Object'

const props = defineProps({
  type: {
    type: Number,
    required: true,
  },
})

/* Вычисляем класс иконки */
const iconClass = computed(() => (props.type == 3 ? '' : 'v-tree__icon_success'))

/* Вычисляем иконку объекта в зависимости от типа */
const type = computed<string>(() => {
  return (ObjectTypes[props.type] || ObjectTypes[3]).icon
})
</script>

<template>
  <VIcons class="v-tree__icon" :class="iconClass" :type />
</template>
